const JP_STREET_NUMBER_SUFFIX_REGEX = /\s\d+(?:-\d+)*$/;

const stripJpStreetNumberSuffix = (value = '') => String(value).replace(JP_STREET_NUMBER_SUFFIX_REGEX, '').trim();

const buildSummaryDisplayText = (candidate = {}) => {
  let displayText = candidate.address_text || '';

  if (candidate.entries > 1) {
    displayText += ` (${candidate.entries})`;
  }

  return displayText;
};

const buildDetailedDisplayText = (candidate = {}) => (
  [
    candidate.street,
    candidate.locality,
    candidate.administrative_area,
    candidate.postal_code
  ].filter(Boolean).join(', ')
);

const normalizeJpSuggestion = (candidate = {}) => {
  if (candidate.isDetailed && candidate.street) {
    const street = stripJpStreetNumberSuffix(candidate.street);

    return {
      ...candidate,
      street,
      displayText: buildDetailedDisplayText({
        ...candidate,
        street
      })
    };
  }

  if (candidate.entries === 1 && candidate.address_text) {
    const addressText = stripJpStreetNumberSuffix(candidate.address_text);

    return {
      ...candidate,
      address_text: addressText,
      displayText: buildSummaryDisplayText({
        ...candidate,
        address_text: addressText
      })
    };
  }

  return candidate;
};

const dedupeSuggestions = (suggestions = []) => {
  const seen = new Set();

  return suggestions.filter((candidate) => {
    const dedupeKey = [
      candidate.isDetailed ? 'detailed' : 'summary',
      candidate.displayText,
      candidate.street || '',
      candidate.address_text || ''
    ].join('|');

    if (seen.has(dedupeKey)) {
      return false;
    }

    seen.add(dedupeKey);
    return true;
  });
};

const applyJpAutocompleteBusinessRules = (suggestions = []) => (
  dedupeSuggestions(suggestions.map(normalizeJpSuggestion))
);

export const applyIntlAutocompleteBusinessRules = (countryCode, suggestions = []) => {
  if (countryCode !== 'JP') {
    return suggestions;
  }

  return applyJpAutocompleteBusinessRules(suggestions);
};

export { stripJpStreetNumberSuffix };
